import React, { useEffect, useState} from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils';
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from '../../components/tab';
import ResourcesTable from './allResources';
import {
  TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import { getAllocatedto, getFilteredCandidates, getCandidates , getProviderResources , getRecruiterResources } from './services'
import { addFilter } from '../../utils/filterNew'
import { viewedpageMixpanel } from '../../utils/mixpanel';
import mixpanel from 'mixpanel-browser';
import { getAPI } from '../../api/api';
import { REACT_APP_COMMON } from '../../utils/common';




function Resources() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  let BreadcrumsValues = ['Resources']
  localStorage.removeItem('candidateLoginId')

  const [draftTotal, setDraftTotal] = useState<number>()
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [total, setTotal] = useState<number>()
  const [verifiedTotal, setVerifiedTotal] = useState<number>()
  const [nonverifedTotal, setNonverifiedTotal] = useState<number>()
  const [certifiedTotal, setCertifiedTotal] = useState<number>()
  const [providerTotal, setProviderTotal] = useState<number>()
  const [draftfreelancerTotal, setDraftfreelancerTotal] = useState<number>()
  const [basicsubmittedTotal, setBasicsubmittedTotal] = useState<number>()
  const [mydraftTotal, setMydraftTotal] = useState<number>()
  const [resources, setResources] = useState<any>()
  const [verified, setVerified] = useState<any>()
  const [nonVerified, setNonVerified] = useState<any>()
  const [certified, setCertified] = useState<any>()
  const [providerResource, setProviderResource] = useState<any>()
  const [draftFreelancer, setDraftFreelancer] = useState<any>()
  const [basicProfileSubmitted, setBasicProfileSubmitted] = useState<any>()
  const [myDraft, setMyDraft] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [filterValues, setFilterValues] = useState<any>(null);
  const [search, setSearch] = useState<string>('');
  const [sort, setSort] = useState<any>([]);
  const [behalf_of, setBehalf_of] = useState<any>()
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()

  const [date, setDate] = useState<any>()
  let cr = localStorage.getItem('role');
  const findTabName = (value: number) => {
    switch(value){
      case 0:
        return 'verified';
        break;
      case 1:
        return 'nonVerified';
        break;
      case 2:
        return 'certified';
        break;
      case 3:
        return 'providerResource';
        break;
      // case 4:
      //   return 'draftFreelancer';
      //   break;
      // case 5:
      //   return 'basicProfile';
      //   break;
      case 4:
        return 'myDraft';
        break;
      case 5:
        return 'allResource';
        break;
      default:
        return ''
    }
  }

  
  useEffect(() => {

    getResources( 0, 25, 1, '', '', '')
    getResources( 1, 25, 1, '', '', '')
    getResources( 2, 25, 1, '', '', '')
    getResources( 3, 25, 1, '', '', '')
    getResources( 4, 25, 1, '', '', '')
    getResources( 5, 25, 1, '', '', '')
    viewedpageMixpanel();
    getAllocation();
    mixpanel.reset()
    
    getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })
   

  }, [])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected)
    
  }

  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const searchChange = (e: string) => {

    const searchEncoded = encodeURIComponent(e)
     
    setSearch(searchEncoded)
    getResources( 0, 25, 1, searchEncoded, filterValues,sort)
    getResources( 1, 25, 1, searchEncoded, filterValues,sort)
    getResources( 2, 25, 1, searchEncoded, filterValues,sort)
    getResources( 3, 25, 1, searchEncoded, filterValues,sort)
    getResources( 4, 25, 1, searchEncoded, filterValues,sort)
    getResources( 5, 25, 1, searchEncoded, filterValues,sort)

    // getResources( 6, 25, 1, e, filterValues,sort)
    // getResources( 7, 25, 1, e, filterValues,sort)

  }

  const getResources = (tabValue: number, pageSize: number, pageNumber: number, searchValue: string, filter?: any,sort?:any) => {
    let tabName = findTabName(tabValue)
    getCandidates(tabName, pageSize, pageNumber, searchValue, filter,sort ).then((response) => {
      if (response && response.status === 1) {
        switch (tabValue){
          case 0:
            setVerified(response.data)
            setVerifiedTotal(response.count)
            break
          case 1:
            setNonVerified(response.data)
            setNonverifiedTotal(response.count)
            break
          case 2:
            setCertified(response.data)
            setCertifiedTotal(response.count)
            break
          case 3:
            setProviderResource(response.data)
            setProviderTotal(response.count)
            break
          case 4:
            setMyDraft(response.data)
            setMydraftTotal(response.count)
            break
          case 5:
            setResources(response.data)
            setTotal(response.count)
            break
          }
      }
    });
  };

  const getResourceTables = () => {

    getResources( 0, 25, 1, search)
    getResources( 1, 25, 1, search)
    getResources( 2, 25, 1, search)
    getResources( 3, 25, 1, search)
    getResources( 4, 25, 1, search)
    getResources( 5, 25, 1, search)
 }
 
 const VerifiedTab = <>Verified <i>{verifiedTotal}</i></>
 const NonVerifiedTab = <>Non-Verified <i>{nonverifedTotal}</i></>
 const CertifiedTab = <>Certified <i>{certifiedTotal}</i></>
 const ProviderResourcesTab = <>Provider Resources <i>{providerTotal}</i></>
 const MyDraftTab = <>My Draft <i>{mydraftTotal}</i></>
 const AllResourceTab = <>All Resource <i>{total}</i></>


 const pageChange = (pageSize: number, pageNumber: number) => {

  let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1; 
  getResources( selectedTab, pageSize, page, search, filterValues,sort )
  
  }
  const applyFilter = (data: any) => {
    
    setBehalf_of(data.filters.behalf_of)
    getResources(0, 25, 1, search, data,sort)
    getResources(1, 25, 1, search, data,sort)
    getResources(2, 25, 1, search, data,sort)
    getResources(3, 25, 1, search, data,sort)
    getResources(4, 25, 1, search, data.filters,sort)
    getResources(5, 25, 1, search, data,sort)
    
    delete data.coreSkillsCombination
    delete data.otherSkillsCombination
    delete data.positionStatusCombination
    data.filters.behalf_of = data.filters.behalf_of !== undefined ? data.filters.behalf_of.name : undefined 
    setFilterValues(data.filters)
  }

  const closeTag = (data: any) => {
  
    if(data.behalf_of){
      if(behalf_of !== undefined){
        data.behalf_of = behalf_of
      }
    }
    let value = {
      filters: data
    }
    applyFilter(value)  
  }

  const applySort = (sort: any) => {
    getResources(0, 25, 1, search, filterValues , sort)
    getResources(1, 25, 1, search, filterValues , sort)
    getResources(2, 25, 1, search, filterValues , sort)
    getResources(3, 25, 1, search, filterValues , sort)
    getResources(4, 25, 1, search, filterValues , sort)
    getResources(5, 25, 1, search, filterValues , sort)
  };

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'allresources'} />
      <div className="dashboardContent">
        <DashboardHeader title={BreadcrumsValues} allocatedTo={allocatedTo} navigateTo={cr === 'CR-RECRUITER' ? '/CRcreateresources' : '../createResources'} type='resources' searchChange={searchChange} applyResourceFilter={applyFilter} filterValues={filterValues} closeTag={closeTag} getProviderResources={getProviderResources} getRecruiterResources={getRecruiterResources} behalf_of={behalf_of} skillsList={skillList} jobRolesList={jobRoleList} />
        <div className={Styles.sourceFilter}>
          {/* <label>Sourced on behalf of</label> */}
          {/* <div className="filterDropdown">
              <DropDownListselect name="Recruiter" data={[]} value={[]} defaultItem="Recruiter" textField="name" defaultValue={[]}/>
              <DropDownListselect name="name" data={[]} value={[]} defaultItem="Name" textField="name" defaultValue={[]}/>
          </div> */}
        </div>
        <section className={Styles.dashboardWrapper}>
          <TabStrip selected={selectedTab} onSelect={handleSelect}>
              <Tab title={VerifiedTab} >
                  <ResourcesTable setSort={setSort} applySort={applySort} data={verified} getTablesValues={getResourceTables} total={verifiedTotal} pageSize={pageChange}/>
              </Tab>
              <Tab title={NonVerifiedTab}>
              <ResourcesTable setSort={setSort} applySort={applySort} data={nonVerified} getTablesValues={getResourceTables} total={nonverifedTotal} pageSize={pageChange} hideSubmittedTo={true} />
              </Tab>
              <Tab title={CertifiedTab}>
                  <ResourcesTable setSort={setSort} applySort={applySort} data={certified} getTablesValues={getResourceTables} total={certifiedTotal} pageSize={pageChange} hideSubmittedTo={true}/>
              </Tab>
              <Tab title={ProviderResourcesTab}>
                  <ResourcesTable setSort={setSort} applySort={applySort} data={providerResource} getTablesValues={getResourceTables} total={providerTotal} pageSize={pageChange}/>
              </Tab>
              {/* <Tab title={DraftFreelancerTab}>
                  <ResourcesTable  data={draftFreelancer} getTablesValues={getResourceTables} total={draftfreelancerTotal} pageSize={pageChange}/>
              </Tab>
              <Tab title={BasicprofileSubmittedTab}>
                  <ResourcesTable data={basicProfileSubmitted} getTablesValues={getResourceTables} total={basicsubmittedTotal} pageSize={pageChange}/>
              </Tab> */}
              <Tab title={MyDraftTab}>
                <ResourcesTable setSort={setSort} applySort={applySort} data={myDraft} getTablesValues={getResourceTables} total={mydraftTotal} pageSize={pageChange} draftKey={true} hideStatus={true} hideSubmittedTo={true}/>
              </Tab>
              <Tab title={AllResourceTab}>
                 <ResourcesTable setSort={setSort} applySort={applySort} data={resources} getTablesValues={getResourceTables} total={total} editDate={() =>setDate(true)} pageSize={pageChange}/>
              </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  )
}

export default Resources
